export const PlanFeatures = ({ plan, existingConnections }) => {
  return (
    <div className="w-full bg-white shadow-lg rounded-2xl p-6 mb-6">
      <h2 className="text-lg font-semibold mb-4">
        What’s included in {plan} plan
      </h2>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-gray-700">
        <li className="flex items-center gap-2">✅ Instagram Connection</li>
        <li className="flex items-center gap-2">
          ✅ AI powered Intelligent Insights
        </li>
        <li className="flex items-center gap-2">✅ Advanced analytics</li>
        <li className="flex items-center gap-2">✅ Team collaboration tools</li>
      </ul>
      <div className="mt-5">
        <h3 className="text-md font-semibold mb-4">Existing add-ons</h3>
        <div className="max-h-64 overflow-y-auto pr-2">
          <ul className="space-y-2 custom-scrollbar">
            {existingConnections.map((item, idx) => (
              <li
                key={`${item.name}-${idx}`}
                className="flex justify-between items-center text-sm border-b border-gray-100 pb-1"
              >
                <span>
                  {item.name}{" "}
                  <span className="text-gray-400">
                    ({item.type === "addon" ? "Add-on" : "Connection"})
                  </span>
                </span>
                <span className="px-3 py-1 rounded-lg text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-300">
                  Included
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
